<template>
    <Modal :show="show" max-width="md" closeable @close="$emit('close')">
        <div class="p-6">
            <SignInPrompt
                :space="space"
                :current-day="currentDay"
                :start-time="startTime"
                @close="$emit('close')"
            />
        </div>
    </Modal>
</template>

<script setup>
    import Modal from "../../InertiaComponents/Modal.vue";
    import SignInPrompt from "./SignInPrompt.vue";

    // The desktop half of the same ask. Modal rather than DialogModal because the prompt supplies
    // its own heading and its own stack of actions, and has no use for a footer bar.
    defineProps({
        show: Boolean,
        space: Object,
        currentDay: Object,
        startTime: Number,
    });

    defineEmits(["close"]);
</script>
